"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getLabel = exports.getComponentInstance = void 0;

var _react = _interopRequireDefault(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/
// 根据组件是Function还是实例进行处理，以便获得对应的实例内容
var getComponentInstance = function getComponentInstance() {
  var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var result = null; // 根据附加组件类型来定义内容

  if (typeof Component !== 'undefined') {
    if ((0, _spauiUtils.isFunction)(Component)) {
      result = _react["default"].createElement(Component, props);
    } else {
      result = Component;
    }
  }

  return result;
}; // 获取文案


exports.getComponentInstance = getComponentInstance;

var getLabel = function getLabel() {
  var treeNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var label = ''; // 如果指定了格式，需要处理一下展示文案格式

  if (format) {
    label = format.replace(/\$\{([0-9a-zA-Z_\-\.]*)\}/gi, function (str) {
      var matchKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var result = '';

      if (matchKey) {
        result = treeNode[matchKey] || '';
      }

      return result;
    });
  } else {
    label = treeNode[key] || '';
  }

  return label;
};

exports.getLabel = getLabel;
var _default = {
  getComponentInstance: getComponentInstance,
  getLabel: getLabel
};
exports["default"] = _default;